<template>
    <div class="Loading">
        <div class="tanchuang">
            <div class="tubiao"></div>
            <!-- <div class="buyVip">火速加载中 ···</div> -->
        </div>  
    </div>
</template>
<style type="text/css" lang='less' scoped>
    .Loading {
        width: 100%;
        height: 100%;
        // background-color: rgba(51,51,51,.65);
        // background-color: rgba(255,255,255,.8);
        position: relative;
        .tanchuang {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -245px;
            margin-top: -60px;
            width: 490px;
            height: 120px;
            // background-color: #fff;
            .tubiao {
                height: 80px;
                width: 80px;
                margin: 0 auto;
                background: url(/imgs/loading/loading.png) no-repeat center center;
                // transform: rotate(360deg);
                // transition: all 1s linear infinite;
                animation: rotate 1.5s linear infinite;
            }
            @keyframes rotate{
                from{
                    transform: rotate(360deg)
                }
                to{
                    transform: rotate(0deg)
                }
            }
            .buyVip {
                font-size: 18px;
                color: #666;
                text-align: center;
                line-height: 40px;

            }
        }
    }  
</style>
<script>
export default {
    props: [ 'data' ],
    data() {
        return { 
        }
    },
    methods: {
      
    },
    watch: { 
       
    },
    mounted() {

       
    },
    created() {
       
    }
}
</script>